<script>
    import DocumentItem from '../../components/document-item/document-item.svelte'
    import InputFile from '../../components/input-file/input-file.svelte'
    import AddInput from '../../components/add-input/add-input.svelte'
    import Button from '../../components/button/button.svelte'
    import RoundInfoIco from '../../components/icons/round-info.svelte'
    import InputDrag from '../../components/input-drag/input.drag.svelte'
    import {documentTypes} from "../../store/upload/document-types"
    import uploadFilesStore from '../../store/upload/upload-everything'
    import RoundCheckIco from '../../components/icons/round-check.svelte'

    let isReading = false
    let files = []

    uploadFilesStore.subscribe(value => {
        files = value
    })

    function homManyRequiredDocumentsAreUploaded(documents) {
        let uploadedRequiredDocuments = 0
        const idFront2021 = files.find(file => file.type.includes(documentTypes.id_2021_front) && file.isValid)
        const idFront2012 = files.find(file => file.type.includes(documentTypes.id_2012_front) && file.isValid)
        const idBack2012 = files.find(file => file.type.includes(documentTypes.id_2012_back) && file.isValid)
        const idFront2005 = files.find(file => file.type.includes(documentTypes.id_2005_front) && file.isValid)
        const idBack2005 = files.find(file => file.type.includes(documentTypes.id_2005_back) && file.isValid)
        const idFrontSK = files.find(file => file.type.includes(documentTypes.id_svk_front))
        const idBackSK = files.find(file => file.type.includes(documentTypes.id_svk_back))
        if (idFront2021 || idFront2012 || idFront2005 || idFrontSK) {
            uploadedRequiredDocuments++
        }
        if (idBack2012 || idBack2005 || idBackSK) {
            uploadedRequiredDocuments++
        }
        return uploadedRequiredDocuments
    }

    function areDocumentsReadyForReading(documents) {
        const idFront2021 = files.find(file => file.type.includes(documentTypes.id_2021_front))
        const idFront2012 = files.find(file => file.type.includes(documentTypes.id_2012_front))
        const idBack2012 = files.find(file => file.type.includes(documentTypes.id_2012_back))
        const idFront2005 = files.find(file => file.type.includes(documentTypes.id_2005_front))
        const idBack2005 = files.find(file => file.type.includes(documentTypes.id_2005_back))
        const idFrontSK = files.find(file => file.type.includes(documentTypes.id_svk_front))
        const idBackSK = files.find(file => file.type.includes(documentTypes.id_svk_back))
        return documents && ((idFront2021 && idBack2012) || (idFront2012 && idBack2012) || (idFront2005 && idBack2005) || (idFrontSK && idBackSK))
    }

    function detectDocuments(event) {
        const files = [...event.detail.files]
        files.forEach(file => {
            uploadFilesStore.detect(file)
        })
    }

    function deleteDocument(event) {
        uploadFilesStore.remove(event.detail.id)
    }

    function upload() {
        if (areDocumentsReadyForReading(files)) {
            uploadFilesStore.upload()
        }
    }


</script>

<style lang="scss">
    .upload-everything {
        h2 {
            font-family: Roboto;
            font-weight: 700;
            font-size: 14px;
            color: #C8C4C4;
            letter-spacing: 1px;
            margin-bottom: 5px;
        }
        .input-wrapper {
            margin-bottom: 40px;
            margin-top: 15px;
        }
        .actions {
            display:flex;
            @media screen and (max-width: 600px) {
                flex-direction: column;
            }
            > div {
                flex: 1 1 50%;
                &.left {
                    padding-left: 30px;
                    .message {
                        font-family: Roboto;
                        font-weight: 300;
                        font-size: 15px;
                        color: #FFFFFF;
                        letter-spacing: 0.2px;
                        line-height: 29px;
                        position: relative;
                        .ico {
                            position: absolute;
                            top: 2px;
                            left: -30px;
                        }
                    }
                    .message-info {
                        font-family: Roboto;
                        font-weight: 300;
                        font-size: 13px;
                        color: #808683;
                        letter-spacing: 0.17px;
                        line-height: 18px;
                        @media screen and (max-width: 600px) {
                            margin-bottom: 20px;
                        }

                    }
                }
                &.right {
                    text-align: right;
                }
            }
        }
    }
</style>

<div class="upload-everything">

   <div class="documents">
        {#each files as file}
            <DocumentItem document={file} on:delete={deleteDocument} />
        {/each}
   </div>

    <div class="input-wrapper">
        <InputDrag on:change={detectDocuments} />
    </div>

    <div class="actions">
        <div class="left">
            <div class="message">
                Uploaded documents <b>{homManyRequiredDocumentsAreUploaded(files)}/2</b>
                <div class="ico">
                    {#if homManyRequiredDocumentsAreUploaded(files) === 2}
                        <RoundCheckIco />
                    {:else}
                        <RoundInfoIco />
                    {/if}
                </div>
            </div>
            <div class="message-info">
                To proceed this operations you must upload every needed documents
            </div>
        </div>
        <div class="right">
            <Button on:click={upload} disabled={!areDocumentsReadyForReading(files)} text="READ documents" />
        </div>
    </div>
</div>
